<template>
  <div class="register">
    <h1 class="register-title">{{ $t('mobileNumber') }}</h1>
    <p class="register-sub-title">{{ $t('registerPhoneNum') }}</p>

    <InputPhoneNumber
      v-model="form.mobile"
      :placeholder="$t('inputPhoneNum')"
      type="digit"
    />

    <md-button
      class="submit-button"
      type="primary"
      :loading="submitLoading"
      :inactive="!isAgree"
      @click="handleSendSMS"
    >
      {{ $t('sendCode') }}
    </md-button>

    <md-dialog
      v-model="showDialog"
      class="agreement-dialog"
      :title="$t('dialog_title')"
      :closable="true"
      :btns="btns"
    >
      <md-scroll-view
        v-if="showDialog"
        :scrolling-x="false"
        @end-reached="btns[1].disabled = false"
      >
        <IdAgreement v-if="$i18n.locale === 'id'" />
        <EnAgreement v-else />
      </md-scroll-view>
    </md-dialog>

    <div>
      {{ $t('befor_agreed') }}
      <a href="javascript:void(0)" @click="showDialog = true">
        {{ $t('privacy_policy_1') }}
      </a>
    </div>
  </div>
</template>

<script>
import { smsLogin } from '@/api/register'
import InputPhoneNumber from '@/components/InputPhoneNumber'
import { Button, Toast, Check, Agree, Dialog, ScrollView } from 'mand-mobile'
import { REMOVE_LEVEL_INFO } from '@/store/modules/common/types'
import { MOBILE_PHONE_MAX_LENGTH, MOBILE_PHONE_MIN_LENGTH } from '@/constants'
import EnAgreement from '@/views/Register/EnAgreement.vue'
import IdAgreement from '@/views/Register/IdAgreement.vue'

export default {
  name: 'Register',

  components: {
    InputPhoneNumber,
    EnAgreement,
    IdAgreement,
    [Button.name]: Button,
    [ScrollView.name]: ScrollView,
    [Dialog.name]: Dialog,
    [Agree.name]: Agree,
    [Check.name]: Check
  },

  data () {
    return {
      showBoard: false,
      image: '',
      showDialog: false,
      form: {
        mobile: ''
      },
      isAgree: false,
      submitLoading: false,
      btns: [
        {
          text: this.$t('cancel'),
          handler: () => {
            this.showDialog = false
          }
        },
        {
          text: this.$t('27c1f06f'),
          disabled: true,
          handler: () => {
            this.isAgree = true
            this.showDialog = false
          }
        }
      ]
    }
  },

  created () {
    this.$store.commit(REMOVE_LEVEL_INFO)
  },

  methods: {
    handleSendSMS () {
      if (this.form.mobile === '') {
        return Toast.failed(this.$t('phoneNotEmpty')) // 手机号不能为空
      }

      if (this.form.mobile.length < MOBILE_PHONE_MIN_LENGTH || this.form.mobile.length > MOBILE_PHONE_MAX_LENGTH) {
        return Toast.failed(this.$t('checkPhoneNum')) // 请检查手机号是否有误
      }

      this.submitLoading = true
      smsLogin(this.form)
        .then(() => {
          this.$router.push({
            name: 'RegisterVerification',
            // 通过内存传参，刷新后回退重新输入手机号
            params: {
              mobile: this.form.mobile
            }
          })
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.register {
  padding: 120px 40px;
}

.register-title {
  margin-bottom: 24px;
  font-size: 48px;
}

.register-sub-title {
  margin-bottom: 104px;
  font-size: 32px;
  color: #7f7f7f;
}

.submit-button {
  margin-top: 300px;
  margin-bottom: 40px;
}

.agreement-dialog {
  ::v-deep .md-dialog-content {
    display: flex;
    flex-flow: column;
    height: 80vh;
    width: 90vw;
  }

  ::v-deep .md-dialog-body {
    flex-grow: 1;
    overflow: hidden;
  }
}
</style>
